(function () {
  const roots = document.querySelectorAll("[data-bandeja-calada-root]");
  if (!roots.length) return;

  roots.forEach((root) => {
    const configNode = root.querySelector("[data-bandeja-config]");
    if (!configNode) return;

    let config = {};
    try {
      config = JSON.parse(configNode.textContent || "{}");
    } catch (_) {
      config = {};
    }

    const state = {
      width: 200,
      height: 50,
      quantity: 1,
      baseColor: "",
      depth: "10",
      letterColor: "",
      cableExit: "",
      designMode: "",
      price: 352,
      galleryIndex: 0,
      svgText: "",
    };

    const PRICING_VERSION = "v1";
    const BASE_VARIANT_ID = Number(config.base_variant_id) || 0;
    const BASE_PRICE_EUR = 80;
    const ADJUSTMENT_VARIANT_BY_EUR = {
      1: 57772648726860,
      2: 57772648759628,
      5: 57772648792396,
      10: 57772648825164,
      20: 57772648857932,
      50: 57772648890700,
      100: 58016910901580,
      250: 58016910934348,
      500: 58016910967116,
      1000: 58016910999884
    };
    const ADJUSTMENT_DENOMS = [1000, 500, 250, 100, 50, 20, 10, 5, 2, 1];

    const baseColors = [
      { id: "blanco", name: "Blanco", swatch: "linear-gradient(135deg, #f9f9f9, #aaaaaa)" },
      { id: "negro", name: "Negro", swatch: "linear-gradient(135deg, #2e333b, #08090d)" },
      { id: "pintado", name: "Pintado", swatch: "linear-gradient(135deg, #da2a8b, #7e0f4f)" },
      { id: "oro-mate", name: "Oro Mate", swatch: "linear-gradient(135deg, #d8c78a, #978246)" },
      { id: "oro-satin", name: "Oro Satín", swatch: "linear-gradient(135deg, #d5c973, #847228)" },
      { id: "plata-satin", name: "Plata Satín", swatch: "linear-gradient(135deg, #d4d4d8, #80848f)" },
      { id: "cobre-satin", name: "Cobre Satín", swatch: "linear-gradient(135deg, #d19875, #7f4f35)" },
      { id: "bronce-satin", name: "Bronce Satín", swatch: "linear-gradient(135deg, #9a8762, #4c3820)" }
    ];

    const letterColorIcons = config.letter_color_icons || {};
    const letterColors = [
      { id: "blanco", name: "Blanco", icon: letterColorIcons.blanco || "" },
      { id: "diseno", name: "Como tu diseño", icon: letterColorIcons.diseno || "" }
    ];

    const designModes = [
      { id: "tengo-mi-diseno", name: "Tengo mi diseño", note: "Subiremos tu arte final y adaptaremos el troquel a medidas de producción." },
      { id: "disenamelo", name: "Diseñámelo Gratis", note: "Explícanos qué y cómo lo quieres. Recibirás una propuesta de diseño antes de fabricación." }
    ];

    const galleryImages = Array.isArray(config.gallery_images) ? config.gallery_images : [];
    const widthInput = root.querySelector("[data-width-input]");
    const heightInput = root.querySelector("[data-height-input]");
    const quantityInput = root.querySelector("[data-quantity-input]");
    const cableExit = root.querySelector("[data-cable-exit]");
    const priceMain = root.querySelector("[data-price-main]");
    const summaryLine = root.querySelector("[data-summary-line]");
    const designNote = root.querySelector("[data-design-note]");
    const baseColorGrid = root.querySelector("[data-base-color-grid]");
    const depthSelect = root.querySelector("[data-depth-select]");
    const letterColorGrid = root.querySelector("[data-letter-color-grid]");
    const designGrid = root.querySelector("[data-design-grid]");
    const galleryMain = root.querySelector("[data-gallery-main]");
    const thumbStrip = root.querySelector("[data-thumb-strip]");
    const addToCartBtn = root.querySelector("[data-add-to-cart]");
    const cartNote = root.querySelector("[data-cart-note]");
    const sizeNote = root.querySelector("[data-size-note]");
    const logoInput = root.querySelector("[data-logo-input]");
    const additionalInfoInput = root.querySelector("[data-additional-info]");
    const galleryPrev = root.querySelector("[data-gallery-prev]");
    const galleryNext = root.querySelector("[data-gallery-next]");
    const lightbox = root.querySelector("[data-lightbox]");
    const lightboxImage = root.querySelector("[data-lightbox-image]");
    const lightboxCloseButtons = root.querySelectorAll("[data-lightbox-close]");
    const lightboxPrev = root.querySelector("[data-lightbox-prev]");
    const lightboxNext = root.querySelector("[data-lightbox-next]");
    const preview3d = root.querySelector("[data-bandeja-3d-preview]");
    const uploadModal = root.querySelector("[data-bandeja-upload-modal]");
    const uploadName = root.querySelector("[data-bandeja-upload-name]");
    const uploadNext = root.querySelector("[data-bandeja-upload-next]");
    const startScreen = root.querySelector("[data-bandeja-start]");
    const workspace = root.querySelector("[data-bandeja-workspace]");

    function showWorkspace() {
      if (startScreen) startScreen.hidden = true;
      if (workspace) workspace.hidden = false;
      window.setTimeout(() => window.dispatchEvent(new Event("resize")), 0);
    }

    let trayPreview = null;
    async function ensureTrayPreview() {
      if (trayPreview || !preview3d) return trayPreview;
      const [THREE, svgModule, controlsModule] = await Promise.all([
        import("https://esm.sh/three@0.160.0"),
        import("https://esm.sh/three@0.160.0/examples/jsm/loaders/SVGLoader.js"),
        import("https://esm.sh/three@0.160.0/examples/jsm/controls/OrbitControls.js")
      ]);
      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(36, 1, 0.1, 5000);
      const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      renderer.setPixelRatio(Math.min(devicePixelRatio || 1, 2));
      renderer.outputColorSpace = THREE.SRGBColorSpace;
      renderer.shadowMap.enabled = true;
      preview3d.appendChild(renderer.domElement);
      scene.add(new THREE.HemisphereLight(0xffffff, 0x302832, 1.5));
      const key = new THREE.DirectionalLight(0xffffff, 2.2);
      key.position.set(-120, 160, 220);
      key.castShadow = true;
      scene.add(key);
      const controls = new controlsModule.OrbitControls(camera, renderer.domElement);
      controls.enableDamping = true;
      controls.enablePan = false;
      controls.minPolarAngle = Math.PI * 0.25;
      controls.maxPolarAngle = Math.PI * 0.72;
      let tray = null;

      function resize() {
        const rect = preview3d.getBoundingClientRect();
        renderer.setSize(Math.max(1, rect.width), Math.max(1, rect.height), false);
        camera.aspect = Math.max(1, rect.width) / Math.max(1, rect.height);
        camera.updateProjectionMatrix();
      }
      new ResizeObserver(resize).observe(preview3d);
      resize();
      (function render() { controls.update(); renderer.render(scene, camera); requestAnimationFrame(render); })();

      function baseHex() {
        return ({ blanco: 0xe8e6df, negro: 0x242426, pintado: 0xb51f70, "oro-mate": 0xb79a51, "oro-satin": 0xc2a83e, "plata-satin": 0xa9abb0, "cobre-satin": 0xa86745, "bronce-satin": 0x655039 })[state.baseColor] || 0xd7d2c8;
      }

      function rebuild() {
        if (!state.svgText) return;
        if (tray) scene.remove(tray);
        tray = new THREE.Group();
        const width = Math.max(20, Number(widthInput?.value) || 200);
        const height = Math.max(20, Number(heightInput?.value) || 50);
        const depth = Math.max(2, Number(depthSelect?.value) || 10);
        const border = Math.max(1.5, Math.min(width, height) * 0.035);
        const face = new THREE.Shape();
        face.moveTo(-width / 2, -height / 2); face.lineTo(width / 2, -height / 2);
        face.lineTo(width / 2, height / 2); face.lineTo(-width / 2, height / 2); face.closePath();
        const parsed = new svgModule.SVGLoader().parse(state.svgText);
        const shapes = parsed.paths.flatMap((path) => svgModule.SVGLoader.createShapes(path));
        const allPoints = shapes.flatMap((shape) => shape.getPoints(48));
        if (allPoints.length) {
          const box = new THREE.Box2().setFromPoints(allPoints);
          const size = box.getSize(new THREE.Vector2());
          const scale = Math.min((width - border * 4) / Math.max(size.x, 1), (height - border * 4) / Math.max(size.y, 1));
          const center = box.getCenter(new THREE.Vector2());
          shapes.forEach((svgShape) => {
            const points = svgShape.getPoints(64).map((p) => new THREE.Vector2((p.x - center.x) * scale, -(p.y - center.y) * scale));
            if (points.length > 2) face.holes.push(new THREE.Path(points));
          });
        }
        const dibond = new THREE.MeshStandardMaterial({ color: baseHex(), roughness: 0.48, metalness: 0.06 });
        const front = new THREE.Mesh(new THREE.ExtrudeGeometry(face, { depth: 0.35, bevelEnabled: false, curveSegments: 24 }), dibond);
        front.position.z = depth / 2;
        front.castShadow = true;
        tray.add(front);
        const acrylic = new THREE.Mesh(new THREE.BoxGeometry(width - border * 2, height - border * 2, 0.35), new THREE.MeshStandardMaterial({ color: 0xfff7e8, emissive: 0xfff1d0, emissiveIntensity: 0.75, roughness: 0.65 }));
        acrylic.position.z = depth / 2 - 0.22;
        tray.add(acrylic);
        [[width, border, 0, height / 2 - border / 2], [width, border, 0, -height / 2 + border / 2], [border, height - border * 2, -width / 2 + border / 2, 0], [border, height - border * 2, width / 2 - border / 2, 0]].forEach(([w, h, x, y]) => {
          const rail = new THREE.Mesh(new THREE.BoxGeometry(w, h, depth), dibond);
          rail.position.set(x, y, 0); rail.castShadow = true; tray.add(rail);
        });
        scene.add(tray);
        const distance = Math.max(width, height) * 1.18;
        camera.position.set(distance * 0.45, distance * 0.28, distance);
        controls.target.set(0, 0, 0);
        controls.update();
      }
      trayPreview = { rebuild };
      return trayPreview;
    }

    async function rebuildTrayPreview() {
      if (!state.svgText) return;
      preview3d.hidden = false;
      (await ensureTrayPreview())?.rebuild();
    }

    function formatEur(value) {
      return new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value);
    }

    function encodeBase64Utf8(str) {
      try {
        return btoa(unescape(encodeURIComponent(String(str || ""))));
      } catch (_) {
        return "";
      }
    }

    function getOptionName(list, id) {
      const match = list.find((option) => option.id === id);
      return match ? match.name : id;
    }

    function selectedBaseVariantId() {
      if (!BASE_VARIANT_ID) {
        throw new Error("Selecciona el producto base de Bandeja calada en el editor del tema.");
      }
      return BASE_VARIANT_ID;
    }

    function buildAdjustmentLines(deltaEur, sharedProps) {
      let remaining = Math.max(0, Math.ceil(deltaEur));
      const lines = [];

      for (const denom of ADJUSTMENT_DENOMS) {
        if (remaining < denom) continue;
        const quantity = Math.floor(remaining / denom);
        remaining -= quantity * denom;
        const variantId = ADJUSTMENT_VARIANT_BY_EUR[denom];
        if (!variantId) continue;
        lines.push({
          id: variantId,
          quantity,
          properties: {
            ...sharedProps,
            _component: "adjustment",
            _adjustment_eur: String(denom)
          }
        });
      }

      return lines;
    }

    function buildCartItems() {
      const configId = `bcfg_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
      const baseVariantId = selectedBaseVariantId();
      const targetTotal = Math.round(state.price);
      const baseQuantity = Math.max(1, state.quantity || 1);
      const baseTotal = BASE_PRICE_EUR * baseQuantity;
      const adjustmentTotal = Math.max(0, Math.ceil(targetTotal - baseTotal));
      const chargedTotal = baseTotal + adjustmentTotal;
      const additionalInfo = String(additionalInfoInput?.value || "").trim();

      const sharedProps = {
        _config_id: configId,
        _pricing_version: PRICING_VERSION,
        _product_type: "bandeja_calada",
        _width_cm: String(state.width),
        _height_cm: String(state.height),
        _base_color: state.baseColor,
        _depth_cm: state.depth,
        _letter_color: state.letterColor,
        _cable_exit: state.cableExit,
        _design_mode: state.designMode
      };

      const readableEsProps = {
        "Ancho (cm)": String(state.width),
        "Alto (cm)": String(state.height),
        "Color base": getOptionName(baseColors, state.baseColor),
        "Grosor": `${state.depth} cm`,
        "Color letras": getOptionName(letterColors, state.letterColor),
        "Salida cable": state.cableExit,
        "Diseño": designModes.find((mode) => mode.id === state.designMode)?.name || state.designMode,
        "Cantidad": String(baseQuantity),
        "Precio final (€)": chargedTotal.toFixed(2)
      };
      if (additionalInfo) {
        readableEsProps["Información adicional"] = additionalInfo;
      }

      const payload = JSON.stringify({
        pricing_version: PRICING_VERSION,
        product_type: "bandeja_calada",
        target_total_eur: targetTotal,
        charged_total_eur: chargedTotal,
        base_price_eur: BASE_PRICE_EUR,
        adjustment_total_eur: adjustmentTotal,
        width_cm: state.width,
        height_cm: state.height,
        quantity: baseQuantity,
        base_color: state.baseColor,
        depth_cm: state.depth,
        letter_color: state.letterColor,
        cable_exit: state.cableExit,
        design_mode: state.designMode,
        additional_info: additionalInfo
      });
      const payloadB64 = encodeBase64Utf8(payload);

      const baseItem = {
        id: baseVariantId,
        quantity: baseQuantity,
        properties: {
          ...readableEsProps,
          ...sharedProps,
          _component: "base",
          _charged_total_eur: chargedTotal.toFixed(2),
          _customizer_payload: payload,
          _desktop_cfg_v1: payloadB64
        }
      };

      const adjustmentItems = buildAdjustmentLines(adjustmentTotal, sharedProps).map((line) => ({
        ...line,
        parent_id: baseVariantId
      }));

      return [baseItem, ...adjustmentItems];
    }

    async function addItemsWithJson(items) {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ items })
      });
      if (!res.ok) {
        const body = await res.text();
        throw new Error(`Error del carrito: ${res.status} ${body}`);
      }
      return res.json();
    }

    async function addBaseItemWithFile(baseItem, file) {
      const formData = new FormData();
      formData.append("id", String(baseItem.id));
      formData.append("quantity", String(baseItem.quantity));

      Object.entries(baseItem.properties || {}).forEach(([key, value]) => {
        formData.append(`properties[${key}]`, String(value ?? ""));
      });
      formData.append("properties[Logo / diseño]", file);

      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Accept": "application/json" },
        credentials: "same-origin",
        body: formData
      });
      if (!res.ok) {
        const body = await res.text();
        throw new Error(`Error del carrito: ${res.status} ${body}`);
      }
      return res;
    }

    function createChoiceCard(option, activeId, group, withPreview = true) {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "bc-choice-card" + (option.id === activeId ? " active" : "");
      button.dataset.group = group;
      button.dataset.id = option.id;
      button.innerHTML = option.icon
        ? `<img class="bc-choice-icon" src="${option.icon}" alt="" loading="lazy"><span class="bc-choice-label">${option.name}</span>`
        : withPreview
          ? `<div class="bc-choice-preview"></div><span class="bc-choice-label">${option.name}</span>`
        : `<span class="bc-choice-label">${option.name}</span>`;
      return button;
    }

    function renderBaseColors() {
      if (!baseColorGrid) return;
      baseColorGrid.innerHTML = "";
      baseColors.forEach((option) => {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "bc-swatch-card" + (option.id === state.baseColor ? " active" : "");
        button.dataset.id = option.id;
        button.style.setProperty("--swatch", option.swatch);
        button.innerHTML = `<div class="bc-swatch-sample" style="--swatch:${option.swatch};"></div><span class="bc-choice-label">${option.name}</span>`;
        baseColorGrid.appendChild(button);
      });
    }

    function renderChoiceGroup(rootNode, options, activeId, group, withPreview = true, extraClass = "") {
      if (!rootNode) return;
      rootNode.innerHTML = "";
      options.forEach((option) => {
        const card = createChoiceCard(option, activeId, group, withPreview);
        if (extraClass) card.classList.add(extraClass);
        rootNode.appendChild(card);
      });
    }

    function renderDesignModes() {
      renderChoiceGroup(designGrid, designModes, state.designMode, "design", true, "bc-design-card");
      const current = designModes.find((option) => option.id === state.designMode);
      if (designNote) {
        designNote.innerHTML = current ? `<strong>${current.name}.</strong> ${current.note}` : "";
      }
    }

    function calculateBaseUnitPrice(width, height) {
      if (width <= 0 || height <= 0) return 0;
      const area = width * height;
      if (area <= 625) return 121;
      if (area <= 2500) return 132;
      if (area <= 5000) return 255;
      if (area <= 7500) return 284;
      if (area <= 10000) return 347;
      return area * 0.03145;
    }

    function recalculatePrice() {
      const width = Number.parseFloat(widthInput?.value) || 0;
      const height = Number.parseFloat(heightInput?.value) || 0;
      const quantity = Math.max(1, Number.parseInt(quantityInput?.value, 10) || 1);

      state.width = width;
      state.height = height;
      state.quantity = quantity;

      let unitPrice = calculateBaseUnitPrice(width, height);
      if (state.baseColor === "oro-mate" || state.baseColor === "oro-satin" || state.baseColor === "cobre-satin") {
        unitPrice *= 1.05;
      }

      const total = unitPrice * quantity;
      state.price = total;
      if (priceMain) priceMain.textContent = formatEur(total);
      if (summaryLine) {
        if (isConfigurationComplete()) {
          summaryLine.textContent = `${width} × ${height} cm · ${getOptionName(baseColors, state.baseColor)} · ${state.depth} cm · ${quantity} ${quantity === 1 ? "unidad" : "unidades"}`;
        } else {
          summaryLine.textContent = "Completa la configuración para ver el resumen.";
        }
      }
      syncFormState();
    }

    function getSizeValidationMessage() {
      if (state.width < 20 || state.height < 20) {
        return "El tamaño es demasiado pequeño. El ancho y el alto deben ser de al menos 20 cm.";
      }
      return "";
    }

    function isConfigurationComplete() {
      return Boolean(
        !getSizeValidationMessage() &&
        state.baseColor &&
        state.depth &&
        state.letterColor &&
        state.cableExit &&
        state.designMode
      );
    }

    function syncFormState() {
      const sizeValidationMessage = getSizeValidationMessage();
      if (sizeNote) {
        sizeNote.hidden = !sizeValidationMessage;
        sizeNote.textContent = sizeValidationMessage;
      }
      if (cartNote) {
        cartNote.classList.remove("is-error");
        cartNote.textContent = "";
      }
      if (addToCartBtn) addToCartBtn.disabled = !isConfigurationComplete();
    }

    function renderGallery() {
      if (!galleryMain || !thumbStrip) return;
      const current = galleryImages[state.galleryIndex];
      galleryMain.innerHTML = current && current.src
        ? `<img class="bc-gallery-main" src="${current.src}" alt="${current.alt || current.label || "Galería"}">`
        : `<div class="bc-gallery-empty">Añade imágenes desde el editor del tema</div>`;

      const buttons = Array.from(thumbStrip.querySelectorAll(".bc-thumb"));
      buttons.forEach((button, index) => button.classList.toggle("active", index === state.galleryIndex));
      renderLightboxImage();
    }

    function showGalleryImage(offset) {
      if (!galleryImages.length) return;
      state.galleryIndex = (state.galleryIndex + offset + galleryImages.length) % galleryImages.length;
      renderGallery();
    }

    function renderLightboxImage() {
      if (!lightboxImage || !lightbox?.classList.contains("is-open")) return;
      const current = galleryImages[state.galleryIndex];
      if (!current || !current.src) return;
      lightboxImage.src = current.src;
      lightboxImage.alt = current.alt || current.label || "Galería";
    }

    function openLightbox() {
      const current = galleryImages[state.galleryIndex];
      if (!lightbox || !lightboxImage || !current || !current.src) return;
      lightbox.classList.add("is-open");
      lightbox.setAttribute("aria-hidden", "false");
      renderLightboxImage();
    }

    function closeLightbox() {
      if (!lightbox || !lightboxImage) return;
      lightbox.classList.remove("is-open");
      lightbox.setAttribute("aria-hidden", "true");
      lightboxImage.removeAttribute("src");
      lightboxImage.alt = "";
    }

    if (baseColorGrid) {
      baseColorGrid.addEventListener("click", (event) => {
        const button = event.target.closest(".bc-swatch-card");
        if (!button) return;
        state.baseColor = button.dataset.id;
        renderBaseColors();
        recalculatePrice();
        rebuildTrayPreview();
      });
    }

    root.addEventListener("click", (event) => {
      const thumb = event.target.closest(".bc-thumb");
      if (thumbStrip && thumb && thumbStrip.contains(thumb)) {
        state.galleryIndex = Number.parseInt(thumb.dataset.index || "0", 10) || 0;
        renderGallery();
        return;
      }

      const galleryImage = event.target.closest(".bc-gallery-main");
      if (galleryMain && galleryImage && galleryMain.contains(galleryImage)) {
        openLightbox();
        return;
      }

      const choice = event.target.closest(".bc-choice-card");
      if (!choice) return;
      const { group, id } = choice.dataset;
      if (group === "letter") state.letterColor = id;
      if (group === "design") state.designMode = id;

      renderChoiceGroup(letterColorGrid, letterColors, state.letterColor, "letter");
      renderDesignModes();
      recalculatePrice();
    });

    galleryPrev?.addEventListener("click", () => showGalleryImage(-1));
    galleryNext?.addEventListener("click", () => showGalleryImage(1));
    lightboxPrev?.addEventListener("click", () => showGalleryImage(-1));
    lightboxNext?.addEventListener("click", () => showGalleryImage(1));
    lightboxCloseButtons.forEach((button) => button.addEventListener("click", closeLightbox));
    document.addEventListener("keydown", (event) => {
      if (!lightbox?.classList.contains("is-open")) return;
      if (event.key === "Escape") closeLightbox();
      if (event.key === "ArrowLeft") showGalleryImage(-1);
      if (event.key === "ArrowRight") showGalleryImage(1);
    });

    widthInput?.addEventListener("input", () => { recalculatePrice(); rebuildTrayPreview(); });
    heightInput?.addEventListener("input", () => { recalculatePrice(); rebuildTrayPreview(); });
    quantityInput?.addEventListener("input", recalculatePrice);
    depthSelect?.addEventListener("change", () => {
      state.depth = depthSelect.value;
      recalculatePrice();
      rebuildTrayPreview();
    });
    cableExit?.addEventListener("change", () => {
      state.cableExit = cableExit.value;
      syncFormState();
    });
    root.querySelector("[data-calculate-btn]")?.addEventListener("click", recalculatePrice);

    root.querySelectorAll("[data-bandeja-upload-open]").forEach((button) => button.addEventListener("click", () => {
      uploadModal?.classList.add("is-open");
      uploadModal?.setAttribute("aria-hidden", "false");
    }));
    root.querySelector("[data-bandeja-upload-select]")?.addEventListener("click", () => logoInput?.click());
    root.querySelectorAll("[data-bandeja-upload-close]").forEach((button) => button.addEventListener("click", () => {
      uploadModal?.classList.remove("is-open");
      uploadModal?.setAttribute("aria-hidden", "true");
    }));
    logoInput?.addEventListener("change", async () => {
      const file = logoInput.files?.[0];
      if (!file) return;
      if (!/svg/i.test(file.type) && !/\.svg$/i.test(file.name)) {
        if (uploadName) uploadName.textContent = "El archivo debe ser SVG.";
        return;
      }
      state.svgText = await file.text();
      if (uploadName) uploadName.textContent = file.name;
      if (uploadNext) uploadNext.disabled = false;
    });
    uploadNext?.addEventListener("click", async () => {
      if (!state.svgText) return;
      uploadModal?.classList.remove("is-open");
      uploadModal?.setAttribute("aria-hidden", "true");
      showWorkspace();
      await rebuildTrayPreview();
    });

    try {
      const transferredArt = JSON.parse(sessionStorage.getItem("corporeas_uploaded_art_v1") || "null");
      if (transferredArt?.dataUrl && /svg/i.test(transferredArt.type || transferredArt.name || "")) {
        fetch(transferredArt.dataUrl).then((response) => response.text()).then(async (svgText) => {
          state.svgText = svgText;
          if (uploadName) uploadName.textContent = transferredArt.name || "diseño.svg";
          showWorkspace();
          await rebuildTrayPreview();
        }).catch(() => {});
      }
    } catch (_) {}

    addToCartBtn?.addEventListener("click", async () => {
      if (!isConfigurationComplete()) {
        syncFormState();
        return;
      }
      try {
        const items = buildCartItems();
        if (!items.length) throw new Error("No se generaron líneas para el carrito.");
        if (cartNote) {
          cartNote.classList.remove("is-error");
          cartNote.textContent = "";
        }
        const uploadedLogo = logoInput?.files?.[0] || null;
        if (uploadedLogo) {
          const [baseItem, ...adjustmentItems] = items;
          const addedBase = await addBaseItemWithFile(baseItem, uploadedLogo);
          if (adjustmentItems.length) {
            let parentLineKey = addedBase?.key || "";
            if (!parentLineKey) {
              const cartRes = await fetch("/cart.js", {
                method: "GET",
                headers: { "Accept": "application/json" },
                credentials: "same-origin"
              });
              if (cartRes.ok) {
                const cart = await cartRes.json();
                const configId = baseItem.properties?._config_id;
                parentLineKey = cart.items?.find((item) =>
                  item?.properties?._config_id === configId && item?.properties?._component === "base"
                )?.key || "";
              }
            }
            if (!parentLineKey) throw new Error("No se pudo vincular el precio calculado con el producto base.");
            const linkedAdjustmentItems = adjustmentItems.map(({ parent_id, ...item }) => ({
              ...item,
              parent_line_key: parentLineKey
            }));
            await addItemsWithJson(linkedAdjustmentItems);
          }
        } else {
          await addItemsWithJson(items);
        }
        window.location.href = "/cart";
      } catch (err) {
        const message = String(err.message || err);
        if (cartNote) {
          cartNote.classList.add("is-error");
          cartNote.textContent = message.includes("producto base de Bandeja calada")
            ? "Selecciona el producto base de Bandeja calada en el editor del tema para poder añadir al carrito."
            : message;
        }
        console.log("[Bandeja calada customizer payload]", {
          width_cm: state.width,
          height_cm: state.height,
          quantity: state.quantity,
          base_color: state.baseColor,
          depth_cm: state.depth,
          letter_color: state.letterColor,
          cable_exit: state.cableExit,
          design_mode: state.designMode,
          logo_file: logoInput?.files?.[0]?.name || "",
          total_eur: Number(state.price.toFixed(2))
        });
      }
    });

    renderBaseColors();
    renderChoiceGroup(letterColorGrid, letterColors, state.letterColor, "letter");
    renderDesignModes();
    renderGallery();
    recalculatePrice();
  });
})();
